// Vendors
import $ from 'jquery';

// department filter is a select element with id ddl_job_openings_department_filter
$('#ddl_job_openings_department_filter').on('change', function () {
  const departmentValue = $(this).val();
  const locationValue = $('#ddl_job_openings_office_filter').val();

  // hide all elements with class .job-opening-list a
  $('.job-opening-list a').hide();

  // show the elements based on the department and location values, using attributes data-department-ids and data-office-ids. selecting 'All departments' or 'all locations' have a value of -1
  if (departmentValue === '-1' && locationValue === '-1') {
    $('.job-opening-list a').show();
  } else if (departmentValue === '-1' && locationValue !== '-1') {
    $(`.job-opening-list a[data-office-ids*="${locationValue}"]`).show();
  } else if (departmentValue !== '-1' && locationValue === '-1') {
    $(`.job-opening-list a[data-department-ids*="${departmentValue}"]`).show();
  } else {
    $(
      `.job-opening-list a[data-department-ids*="${departmentValue}"][data-office-ids*="${locationValue}"]`
    ).show();
  }
});

// location filter is a select element with id ddl_job_openings_office_filter
$('#ddl_job_openings_office_filter').on('change', function () {
  const locationValue = $(this).val();
  const departmentValue = $('#ddl_job_openings_department_filter').val();

  // hide all elements with class .job-opening-list a
  $('.job-opening-list a').hide();

  // show the elements based on the department and location values, using attributes data-department-ids and data-office-ids. selecting 'All departments' or 'all locations' have a value of -1
  if (departmentValue === '-1' && locationValue === '-1') {
    $('.job-opening-list a').show();
  } else if (departmentValue === '-1' && locationValue !== '-1') {
    $(`.job-opening-list a[data-office-ids*="${locationValue}"]`).show();
  } else if (departmentValue !== '-1' && locationValue === '-1') {
    $(`.job-opening-list a[data-department-ids*="${departmentValue}"]`).show();
  } else {
    $(
      `.job-opening-list a[data-department-ids*="${departmentValue}"][data-office-ids*="${locationValue}"]`
    ).show();
  }
});
